import { SectionCaption } from '@app/core/components/SectionCaption';
import { BaseReportView } from '@app/modules/audit/modules/global-audit/screens/common/BaseReportView';
import { GipReportInfo } from '@app/modules/audit/modules/global-audit/screens/gip/gip-report/config/info/GipReportInfo';
import { auditReports } from '@mi-front/api-clients';
import { Report } from '@mi-front/core';
import { Box } from '@mui/material';
import { defineMessage } from 'react-intl';

interface GipReportViewSharedProps {
  report: auditReports.GipReportDto | auditReports.GipAltReportDto;
  actions: React.ReactNode;
  exportInfo?: React.ReactNode;
}

const configTitleMessage = defineMessage({
  id: 'audit.gipReport.configTitle',
  defaultMessage: 'Configuración de reporte',
});

const exportTitleMessage = defineMessage({
  id: 'audit.reportsView.export',
  defaultMessage: 'Export de evidencia',
});

/**
 * Shared presentational component for GIP and GIP Alternative reports.
 *
 * This component handles the common layout and structure for both report types,
 * while allowing each report type to provide its own export info implementation
 * through the exportInfo prop. This separation allows for different API patterns
 * while maintaining consistent UI structure.
 *
 * @param report - The report data (GipReport or GipAlternativeReport)
 * @param actions - The actions component (typically GipReportActions)
 * @param exportInfo - Optional export info component specific to the report type
 * @param showExport - Whether to show the export section (defaults to true)
 */
export function GipDetails({ report, actions, exportInfo }: GipReportViewSharedProps) {
  return (
    <BaseReportView report={report as unknown as Report} actions={actions}>
      <Box mt={3}>
        <SectionCaption message={configTitleMessage} />
        <GipReportInfo config={report.data.config} />
      </Box>
      {exportInfo && (
        <Box mt={3}>
          <SectionCaption message={exportTitleMessage} />
          {exportInfo}
        </Box>
      )}
    </BaseReportView>
  );
}
